module.exports = __webpack_public_path__ + "static/184172ce.PayPal.png";